import { render, staticRenderFns } from "./data_search.vue?vue&type=template&id=63863d9c&scoped=true"
import script from "./data_search.vue?vue&type=script&lang=js"
export * from "./data_search.vue?vue&type=script&lang=js"
import style0 from "./data_search.vue?vue&type=style&index=0&id=63863d9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63863d9c",
  null
  
)

export default component.exports